import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';

import { ToolsAndMaterialsAssignment } from '../../../shared/interfaces';
import { AppSettings } from '../../../shared/models';
import { AbstractBasicDataApiService } from '../abstract-basic-data-api.service';

@Injectable({
  providedIn: 'root'
})
export class ToolsAndMaterialsAssignmentApiService extends AbstractBasicDataApiService<ToolsAndMaterialsAssignment> {
  constructor(
    protected http: HttpClient
  ) {
    super(http, AppSettings.endpoints.application.toolsAndMaterialsAssignment);
  }
}
